import { useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";

export const CreatableSelectField = ({
  name,
  options,
  isMulti,
  values,
  handleChange,
  handleBlur,
  placeholder,
  onKeyDown,
  fieldLabel,
  fieldName,
  setFieldError,
  setFieldValue,
  errors,
  touched,
  valuess,
  isClearable,
  isDisabled,
  isAttribute,
  className,
  isRVStyle = false,
  onCreateOption,
}) => {
  const layoutModeType = useSelector((state) => state.Layout.layoutModeType);

  const customStyles = {
    control: (styles, { isFocused, errors, touched }) => ({
      ...styles,
      borderRadius: "0.5rem",
      borderColor:
        layoutModeType === "dark"
          ? isFocused
            ? "#0078A3"
            : "#495057"
          : "#ced4da", // Apply red border if there is an error, otherwise handle focused state
      backgroundColor: layoutModeType === "dark" ? "#212529" : "white",
      color: layoutModeType === "dark" ? "white" : "black",
      "&:hover": {
        borderColor:
          errors && touched
            ? "red"
            : isFocused
            ? "#0078A3"
            : layoutModeType === "dark"
            ? "#495057"
            : "#ced4da",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "white" : provided.color,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: layoutModeType === "dark" ? "#212529" : "#0078A3",
      color: "white",
    }),
  };

  const rvCustomStyles = {
    control: (styles, { isFocused, errors, touched }) => ({
      ...styles,
      borderRadius: "0.5rem",
      backgroundColor: isDisabled ? "#EFF2F7" : "white",
      fontWeight: "normal",
      fontSize: "14px",
      color: "black",
      boxShadow: "none",
      borderColor: className?.includes("error-input") ? "#f06548" : "#ccc",
      "&:hover": {
        borderColor: className?.includes("error-input") ? "#f06548" : "grey",
      },
      maxHeight: "30px",
      overflowY: "auto",
      flexWrap: "wrap",
      fontWeight: "normal",
      fontSize: "14px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#f5f5f5"
        : state.isSelected
        ? "white"
        : "white",
      color: state.data.__isNew__ // only apply style to the "create new" option
        ? "#FD7545"
        : "black",
      fontWeight: "normal",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: "#f5f5f5", // slightly different hover color
        filter: "brightness(0.95)",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#f5f5f5"
        : state.isSelected
        ? "white"
        : "white",
      color: "black",
      fontWeight: "normal",
      fontSize: "14px",
    }),
  };

  const handleSelectChange = (selectedOptions) => {
    if (fieldName === "SelfcareAttribute" && selectedOptions.length > 2) {
      setFieldError(name, "You can select only up to 2 options");
    } else {
      // setFieldError(name, "");
      setFieldValue(name, selectedOptions);
    }
  };

  return (
    <>
      <CreatableSelect
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: layoutModeType === "dark" ? "#495057" : "#015E7F",
            primary25: layoutModeType === "dark" ? "#343a40" : "#015E7F",
            primary50: layoutModeType === "dark" ? "#495057" : "#015E7F",
            primary75: layoutModeType === "dark" ? "#495057" : "#015E7F",
          },
        })}
        className={
          className?.includes("error-input") && isRVStyle ? "" : className
        }
        // menuPortalTarget={document.body}
        value={values}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        onChange={isAttribute ? handleSelectChange : handleChange}
        onBlur={handleBlur}
        styles={rvCustomStyles}
        name={name}
        isMulti={isMulti}
        options={options}
        isClearable={isClearable}
        isDisabled={isDisabled}
        noOptionsMessage={() => "Create a new option"}
        components={{ IndicatorSeparator: () => null }}
        {...(onCreateOption ? { onCreateOption } : {})}
        formatCreateLabel={(inputValue) => `Create New "${inputValue}"`}
        menuPosition="fixed"
      />
      {touched && errors && (
        <div className="text-danger mt-1 fs-6">{errors}</div>
      )}
    </>
  );
};
